import { $host } from ".";
import { jwtDecode } from 'jwt-decode';

export const signInLogin = async (login, password) => {
    try {
        const response = await $host.post('/auth/login', { login, password });
        
        if (!response.data?.token) {
            throw new Error('Token not found in response');
        }

        const token = response.data.token;
        localStorage.setItem('token', token);
        
        return jwtDecode(token);
    } catch (error) {
        console.error('Login error:', error);
        throw error; 
    }
};